import {
  requestSearch,
  requestHistoryList, // ここで定義取り出してる
  requestSave,
  requestHistoryDetail,
} from '@/api/purchaseList';

const state = {
  resultPurchaseSearch: null,
  resultPurchaseHistoryList: null,
  resultPurchaseSave: null,
  resultPurchaseHistoryDetail: null,
};

const getters = {
  resultPurchaseSearch: (state) => state.resultPurchaseSearch,
  resultPurchaseHistoryList: (state) => state.resultPurchaseHistoryList,
  resultPurchaseSave: (state) => state.resultPurchaseSave,
  resultPurchaseHistoryDetail: (state) => state.resultPurchaseHistoryDetail,
};

const actions = {
  async search({ commit, dispatch, rootGetters }, { pageNumber, postParam }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const postParams = postParam;
    const page = pageNumber;
    const result = await requestSearch({ csrfToken, page, postParams }); // APIどれを呼び出すか
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    commit('setRequestSearch', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async save({ commit, dispatch, rootGetters }, { postParam }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const postParams = postParam;
    const result = await requestSave({ csrfToken, postParams });
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    commit('setRequestSave', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  // 以下get
  async historyList({ commit, dispatch }, { pageNumber }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestHistoryList({ pageNumber });
    commit('setRequestHistoryList', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async historyDetail({ commit, dispatch }, { historyId }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestHistoryDetail({ historyId });
    commit('setRequestHistoryDetail', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  clearPurchase({ commit }) {
    commit('setRequestSearch', []);
  },
};

const mutations = {
  setRequestSearch(state, data) {
    state.resultPurchaseSearch = data;
  },
  setRequestHistoryList(state, data) {
    state.resultPurchaseHistoryList = data;
  },
  setRequestSave(state, data) {
    state.resultPurchaseSave = data;
  },
  setRequestHistoryDetail(state, data) {
    state.resultPurchaseHistoryDetail = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
